// CryptoLineChart.jsx
import React from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  ReferenceLine,
} from 'recharts';

export default function CryptoLineChart({ data, up, isStable }) {
  // 1) Format & sort the data
  const formatted = data
    .map(({ time, price }) => ({
      time: new Date(time).getTime(),
      price,
    }))
    .sort((a, b) => a.time - b.time);

  // 2) Find high & low
  const prices   = formatted.map(d => d.price);
  const maxPrice = Math.max(...prices);
  const minPrice = Math.min(...prices);

  // 3) Choose color
  let strokeColor = up ? '#4CAF50' : '#E63946';

  let yAxisDomain = ['dataMin', 'dataMax']

  if(isStable) {
    yAxisDomain = [-10000, 10000]
    strokeColor = '#4CAF50'
  }

  return (
    <ResponsiveContainer width="100%" height={120}>
      <LineChart
        data={formatted}
        margin={{ top: 40, right: 0, bottom: 10, left: 0 }}
      >
        <XAxis dataKey="time" type="number" domain={['dataMin','dataMax']} hide />
        <YAxis
            domain={yAxisDomain} hide />

        {/* sparkline */}
        <Line
          type="monotone"
          dataKey="price"
          stroke={strokeColor}
          strokeWidth={2}
          dot={false}
          activeDot={false}
          fill={strokeColor}
        />

        {/* <ReferenceLine
          y={maxPrice}
          stroke="none"
          label={{
            position: 'left',
            dx: 35,  // nudge it further left if you like
            value: `$${maxPrice.toFixed(2)}`,
            fill: strokeColor,
            fontSize: 12,
            fontWeight: 'bold',
          }}
        />

        <ReferenceLine
          y={minPrice}
          stroke="none"
          label={{
            position: 'left',
            dx: 35,
            dy: 4,   // nudge it down a bit below the line
            value: `$${minPrice.toFixed(2)}`,
            fill: strokeColor,
            fontSize: 12,
            fontWeight: 'bold',
          }}
        /> */}
      </LineChart>
    </ResponsiveContainer>
  );
}